import { Injectable } from '@angular/core';

import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';

import { ConfirmationDialogComponent } from './common/confirmation-dialog/confirmation-dialog.component';

export interface ComponentCanDeactivate {
	canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard  {
	constructor(private dialog: MatDialog) {}

	canDeactivate(
		component: ComponentCanDeactivate
	): boolean | Observable<boolean> | Promise<boolean> {
		return component.canDeactivate() ? true : this.openConfirmDialog();
	}

	async openConfirmDialog(): Promise<boolean> {
		return await this.dialog
			.open(ConfirmationDialogComponent, {
				width: '500px',
				data: {
					title: 'Unsaved changes',
					body: `You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.`,
					cancelButtonText: 'Cancel',
					ConfirmButtonText: 'OK',
				},
				disableClose: true,
			})
			.afterClosed()
			.toPromise()
			.then((response) => {
				return response === true;
			});
	}
}
